import React from 'react';
import { TypedMemo } from '../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the picker; each part uses its own slice of it */
import styles from './SongPicker.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SongPickerGroupProps {
  title: string;
  sub: string;
  testId: string;
}

/** One group of the picker (design t1): the heading, its order, and a grid of cards. */
const SongPickerGroupComponent: React.FC<React.PropsWithChildren<SongPickerGroupProps>> = ({
  title,
  sub,
  testId,
  children,
}) => (
  <section className={styles.group} data-testid={testId}>
    <div className={styles.groupHead}>
      <h3>{title}</h3>
      <span className={styles.eyebrow}>{sub}</span>
    </div>
    <div className={styles.grid}>{children}</div>
  </section>
);

export const SongPickerGroup = TypedMemo(SongPickerGroupComponent);
